import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>404</h1>
      <p style={styles.message}>Oops! The page you’re looking for can’t be found.</p>
      <div style={styles.actions}>
        <button style={styles.button} onClick={() => navigate(-1)}>
          Go Back
        </button>
        <Link to='/' style={styles.link}>
          Go Home
        </Link>
      </div>
    </div>
  )
}

// Inline styles just for example; you can move them to CSS or a styled component
const styles = {
  container: {
    textAlign: 'center',
    padding: '4rem 1rem',
    minHeight: '60vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  title: {
    fontSize: '4rem',
    margin: '0.5rem 0'
  },
  message: {
    fontSize: '1.25rem',
    marginBottom: '2rem'
  },
  actions: {
    display: 'flex',
    gap: '1rem'
  },
  button: {
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    cursor: 'pointer'
  },
  link: {
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    textDecoration: 'none',
    color: '#fff',
    backgroundColor: '#007bff',
    borderRadius: '4px'
  }
}
